import classNames from 'classnames';

import styles from './Container.module.scss';

export type ContainerWidth = 'Small' | 'Medium' | 'Standard' | 'Full width' | '';

export interface ContainerProps {
	width: ContainerWidth;
	children: React.ReactNode;
	className?: string;
}

export const UI_Container = ({ width = 'Standard', children, className }: ContainerProps) => {
	width = width === '' ? 'Standard' : width;

	return (
		<div
			className={classNames(
				styles.Container,
				{ [styles.Container___standard]: width === 'Standard' },
				{ [styles.Container___narrow]: width === 'Small' },
				{ [styles.Container___medium]: width === 'Medium' },
				{ 'u-narrow-content-width': width === 'Small' },
				className,
			)}
		>
			{children}
		</div>
	);
};
